import { ApiModule, type PaginatedResponseData } from '@common/index';
import type { LegislationItem, Legislation } from '../models';

export class LegislationApi extends ApiModule {
  protected endpoint = '/legislation';

  public async pageLegislations(params: any) {
    if (params.sort == null) {
      params.sort = 'id,desc';
    }
    return this.api.post<PaginatedResponseData<LegislationItem>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=${params.sort ?? ''}`,
      {
        ...params
      }
    );
  }

  public loadLegislationDetails(id: number) {
    return this.api.get<Legislation>(`${this.endpoint}?id=${id}`);
  }

  public saveLegislation(params: any) {
    return this.api.post(`${this.endpoint}`, {
      ...params
    });
  }

  public deleteLegislation(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }
  public getList(id: number | undefined) {
    if (id) {
      return this.api.get<Legislation[]>(`${this.endpoint}/list?id=${id}`);
    } else {
      return this.api.get<Legislation[]>(`${this.endpoint}/list`);
    }
  }
}
